import { createContext } from 'react';

export type HeadTagName = 'link' | 'meta' | 'title';

export type HeadTagGroup = {
  id: string;
  tags: HeadTag[];
};

export type HeadTag<TTag extends HeadTagName = HeadTagName> = {
  tagName: TTag;
  props: React.ComponentPropsWithoutRef<TTag>;
};

export interface HeadContextType {
  groups: HeadTagGroup[];
  setGroup: (id: string, tags: HeadTag[]) => void;
  removeGroup: (id: string) => void;
}

export const HeadContext = createContext<HeadContextType>({} as HeadContextType);
